import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MyDataService } from 'src/app/services/data/data.service';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets/tickets.service';

@Component({
  selector: 'app-casos',
  templateUrl: './casos.component.html',
  styleUrls: ['./casos.component.scss'],
})
export class CasosComponent implements OnInit {
  ticketsAbiertos: any = [];

  ticketsCerrados: any = [];

  user: any = null;

  project: any = null;

  private destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private ticketsSvc: TicketsService,
    private dataSvc: MyDataService,
    private snackBarService: SnackBarService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
    const user = this.dataSvc.getUserPlatform();
    if (user) {
      this.user = user;
      if (this.user && this.project) {
        this.getTicketsCliente();
      }
    } else {
      this.dataSvc.getUserObservable().subscribe((value) => {
        this.user = value;
        if (this.user && this.project) {
          this.getTicketsCliente();
        }
      });
    }
    if (proyectoPlatform) {
      this.project = proyectoPlatform;
      if (this.user && this.project) {
        this.getTicketsCliente();
      }
    } else {
      this.dataSvc.getFkEntityPlatformObservable().subscribe((value) => {
        this.project = value;
        if (this.user && this.project) {
          this.getTicketsCliente();
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }

  navigateToNuevoCaso() {
    this.router.navigate(['/nuevo-caso']);
  }

  goTicket(ticket: any) {
    this.router.navigate([`/caso/${ticket}`]);
  }

  buscarEstadoPorNombre(nombre: string) {
    return this.translocoService.translate('issues.status.' + nombre);
  }

  formatFecha(fechaOriginal: string) {
    if (fechaOriginal) {
      const fechaFormateada = moment(fechaOriginal).format('DD-MM-YYYY HH:mm');
      return fechaFormateada;
    } else {
      return '';
    }
  }

  getTicketsCliente() {
    this.ticketsSvc
      .getTicketsCliente(this.project, this.user?.cliente?.ID)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.ticketsAbiertos = response.ticketsAbiertos;
          this.ticketsCerrados = response.ticketsCerrados;
        },
        error: (e) => {
          console.log(e);
          this.showSnackBarError(
            this.translocoService.translate('issues.error.loadTickets')
          );
        },
      });
  }
}
